/* eslint-disable */ import { attachSingleReferenceComponent, detailComponent, memoEval, referenceComponent, sceneEntityPropertiesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Wall } from '../model/index.js';
export const topWallItemComponents = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'TopWallItem.$wall', true).withAlias('TopWallItem'), Wall, 'wallId'),
    attachComponent.withComponent(detailComponent, 'default', true).withAlias('TopWallItem').attach(memoEval((self)=>[
            self.$name,
            self.$sku,
            self.$description,
            self.$thumbnailUrl
        ], ($name, $sku, $description, $thumbnailUrl)=>({
            title: $name,
            subtitle: $sku,
            description: $description,
            thumbnailUrl: $thumbnailUrl
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withAlias('TopWallItem').attach(memoEval((self)=>[
            self.x,
            self.$offsetY
        ], (x, $offsetY)=>({
            offsetX: x,
            offsetY: $offsetY
        })))
];

//# sourceMappingURL=top-wall-item.js.map